<template>

    <vue-scroll :ops="$ops">
    <div v-loading="$parentInfo.studentCourseRecord.loading" :style="{'height': $parentInfo.clientHeight-550+$parentInfo.heightChange+'px'}" v-if="isMounted">
        <el-tabs v-model="$parentInfo.studentCourseRecord.activeTab"
                 :v-loading=$parentInfo.studentCourseRecord.loading>
            <el-tab-pane label="在读" name="1">
                <div v-if="$parentInfo.studentCourseRecord.activeTab==1">
                    <div v-for="studentActivePeriod in $parentInfo.studentCourseRecord.studentActivePeriods"
                         :key="studentActivePeriod.id"
                         style="border-bottom: 1px solid #eee">
                        <el-row :gutter="20">
                            <el-col align="left" :span="6">课程名称：{{studentActivePeriod.course_name}}</el-col>
                            <el-col align="left" :span="6">班级名称：{{studentActivePeriod.class_name}}</el-col>
                            <el-col align="left" :span="6">校区：{{studentActivePeriod.section_name}}</el-col>
                            <el-col align="left" :span="6">年级：{{studentActivePeriod.grade_name}}</el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col align="left" :span="6">科目：{{studentActivePeriod.subject_name}}</el-col>
                            <el-col align="left" :span="6">老师：<span v-for="teacher in studentActivePeriod.teacher_name"
                                                                    :key="teacher.id">{{teacher}}</span>
                            </el-col>
                            <el-col align="left" :span="6">教室：<span
                                    v-for="classroom in studentActivePeriod.classroom_name"
                                    :key="classroom.id">{{classroom}}</span>
                            </el-col>
                            <el-col align="left" :span="6">
                                课时数量：{{studentActivePeriod.period}}<span v-if="studentActivePeriod.studentUsePeriod">（剩余
                                {{studentActivePeriod.studentUsePeriod.active_count}}）</span><span
                                    v-else>（获取剩余课时失败）</span>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col align="left" :span="6">时间：{{studentActivePeriod.template_time}}</el-col>
                            <el-col align="left" :span="6">原价：{{studentActivePeriod.original_unit_period_price}}
                            </el-col>
                            <el-col align="left" :span="6">折后价：{{studentActivePeriod.unit_period_price}}</el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col align="left" :span="6">
                                缺席课时：<span v-if="studentActivePeriod.studentUsePeriod">（剩余
                                {{studentActivePeriod.studentUsePeriod.absent_count}}）</span><span
                                    v-else>（获取缺席课时失败）</span>
                            </el-col>
                        </el-row>
                        <div slot="footer" class="dialog-footer" align="right" v-if="!$parentInfo.studentCourseRecord.disableYN">
                            <el-button type="primary" @click="handleCancelCourse(studentActivePeriod)"
                            >取消课程
                            </el-button>
                            <el-button type="primary"
                                       @click="handleChangeCourse(studentActivePeriod)"
                            >换课
                            </el-button>
                            <el-button type="primary"
                                       @click="handleFinishCourse(studentActivePeriod)"
                            >结课
                            </el-button>
                        </div>

                    </div>
                </div>

            </el-tab-pane>
            <el-tab-pane label="完成" name="2">
                <div v-if="$parentInfo.studentCourseRecord.activeTab==2">
                    <div v-for="studentFinishedPeriod in $parentInfo.studentCourseRecord.studentFinishedPeriods"
                     :key="studentFinishedPeriod.id">
                    <el-row :gutter="20">
                        <el-col align="left" :span="6">课程名称：{{studentFinishedPeriod.course_name}}</el-col>
                        <el-col align="left" :span="6">班级名称：{{studentFinishedPeriod.class_name}}</el-col>
                        <el-col align="left" :span="6">校区：{{studentFinishedPeriod.section_name}}</el-col>
                        <el-col align="left" :span="6">年级：{{studentFinishedPeriod.grade_name}}</el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col align="left" :span="6">科目：{{studentFinishedPeriod.subject_name}}</el-col>
                        <el-col align="left" :span="6">老师：<span
                                v-for="teacher in studentFinishedPeriod.teacher_name"
                                :key="teacher.id">{{teacher}}</span>
                        </el-col>
                        <el-col align="left" :span="6">教室：<span
                                v-for="classroom in studentFinishedPeriod.classroom_name" :key="classroom.id">{{classroom}}</span>
                        </el-col>
                        <el-col align="left" :span="6">
                            课时数量：{{studentFinishedPeriod.period}}<span
                                v-if="studentFinishedPeriod.studentUsePeriod">（剩余
                                {{studentFinishedPeriod.studentUsePeriod.active_count}}）</span><span
                                v-else>（获取剩余课时失败）</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col align="left" :span="6">原价：{{studentFinishedPeriod.original_unit_period_price}}
                        </el-col>
                        <el-col align="left" :span="6">折后价：{{studentFinishedPeriod.unit_period_price}}</el-col>
                        <el-col align="left" :span="6">
                            缺席次数：<span v-if="studentFinishedPeriod.studentUsePeriod">（剩余
                                {{studentFinishedPeriod.studentUsePeriod.absent_count}}）</span><span
                                v-else>（获取缺席课时失败）</span>
                        </el-col>
                        <el-col align="left" :span="6">评分：<span v-if="studentFinishedPeriod.studentUsePeriod">（剩余
                                {{studentFinishedPeriod.studentUsePeriod.score}}）</span><span v-else>（获取评分失败）</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col align="right" :span="24">
                            <el-button type="primary"
                                       @click="handleStudentCourseEvaluation(studentFinishedPeriod.id)"
                                       :disabled="$parentInfo.studentCourseRecord.disableYN">
                                评价
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="取消" name="3">
                <div v-if="$parentInfo.studentCourseRecord.activeTab==3">
                    <div v-for="studentCancelPeriod in $parentInfo.studentCourseRecord.studentCancelPeriods"
                     :key="studentCancelPeriod.id">
                    <el-row :gutter="20">
                        <el-col align="left" :span="6">课程名称：{{studentCancelPeriod.course_name}}</el-col>
                        <el-col align="left" :span="6">班级名称：{{studentCancelPeriod.class_name}}</el-col>
                        <el-col align="left" :span="6">校区：{{studentCancelPeriod.section_name}}</el-col>
                        <el-col align="left" :span="6">年级：{{studentCancelPeriod.grade_name}}</el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col align="left" :span="6">科目：{{studentCancelPeriod.subject_name}}</el-col>
                        <el-col align="left" :span="6">
                            课时数量：{{studentCancelPeriod.period}}<span v-if="studentCancelPeriod.studentUsePeriod">（剩余
                                {{studentCancelPeriod.studentUsePeriod.active_count}}）</span><span
                                v-else>（获取剩余课时失败）</span>
                        </el-col>
                        <el-col align="left" :span="6">
                            缺席次数：
                            <span v-if="studentCancelPeriod.studentUsePeriod">
                                {{studentCancelPeriod.studentUsePeriod.absent_count}}</span>
                            <span v-else>（获取缺席课时失败）</span>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col align="left" :span="6">原价：{{studentCancelPeriod.original_unit_period_price}}
                        </el-col>
                        <el-col align="left" :span="6">折后价：{{studentCancelPeriod.unit_period_price}}</el-col>
                    </el-row>
                    <hr class="m-t-0 m-b-40">
                </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="历史" name="4">
                <StudentHistoryPeriod v-if="$parentInfo.studentCourseRecord.activeTab==4"></StudentHistoryPeriod>
            </el-tab-pane>
            <!--<el-tab-pane label="合同" name="5" v-if="$parentInfo.powers.includes(63)">-->
            <el-tab-pane label="合同" name="5">
                <StudentInvoice v-if="$parentInfo.studentCourseRecord.activeTab==5"></StudentInvoice>
            </el-tab-pane>
            <el-tab-pane label="定金合同" name="6">
                <EarnestInvoice v-if="$parentInfo.studentCourseRecord.activeTab==6"></EarnestInvoice>
            </el-tab-pane>
        </el-tabs>
    </div>
    </vue-scroll>
</template>

<script>
    import StudentInvoice from '@/views/Student/Invoice/StudentInvoice.vue';
    import StudentHistoryPeriod from './StudentHistoryPeriod.vue';
    import EarnestInvoice from "../../Invoice/EarnestInvoice";
    export default {
        data() {
            return {
                isMounted: false
            };
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            }
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowStudentPeriod();
            this.isMounted = true;
        },
        components: {
            StudentInvoice,
            StudentHistoryPeriod,
            EarnestInvoice
        },
        methods: {
            //studentCourseRecord
            handleShowStudentPeriod() {
                this.$wApi.send(this.$parentInfo.path, 'studentCourseRecord', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleStudentCourseEvaluation(studentPeriod_id) {
                this.$Win.openModal('Dialog_StudentCourseEvaluation', 600, 300, '评价', {
                    'studentPeriod_id': studentPeriod_id,
                });
            },
            // 取消课程
            handleCancelCourse(studentActivePeriod) {
                this.$Win.openModal('Dialog_CancelCourse', 600, 250, '取消课程-' + studentActivePeriod.course_name + '-' + studentActivePeriod.template_time + '-' + studentActivePeriod.teacher_name, {
                    'studentPeriod_id': studentActivePeriod.id
                });
            },
            // 更换课程
            handleChangeCourse(studentActivePeriod) {
                this.$Win.openModal('Dialog_ChangeCourse', 600, 250, '换课-' + studentActivePeriod.course_name + '-' + studentActivePeriod.template_time + '-' + studentActivePeriod.teacher_name, {
                    'studentPeriod_id': studentActivePeriod.id,
                    'originalClass_id': studentActivePeriod.class_id,
                });
            },
            handleFinishCourse(studentActivePeriod){
                this.$confirm('确认结课?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.$parentInfo.path, 'studentFinishedPeriod', {
                        'student_id': this.$parentInfo.student_id,
                        'studentPeriod_id': studentActivePeriod.id,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        }
    };
</script>
